import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { Select } from '@ngxs/store';
import { ClientSelectionState } from '../../../state/ClientSelectionState/ClientSelection.state';

@Component({
  selector: 'lib-permissions-list',
  templateUrl: './permissions-list.component.html',
  styleUrls: ['./permissions-list.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PermissionsListComponent),
      multi: true
    }
  ],
  standalone: false
})
export class PermissionsListComponent implements OnInit, ControlValueAccessor {
  @Input()
  public availableOptions: PermissionGroup[];

  public options: SelectablePermissionGroup[];

  get flattenedPermissions() {
    return this.options.flatMap(x => x.permissions);
  }

  private onChange = _ => {};
  constructor() {}

  ngOnInit(): void {
    this.options = this.availableOptions.map(x => {
      return {
        title: x.title,
        permissions: x.permissions.map(y => {
          return {
            val: y.val,
            display: y.display,
            selected: false,
            canDisplay: y.canDisplay
          };
        }),
        canDisplay: x.canDisplay
      };
    });
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {}

  setDisabledState(isDisabled: boolean): void {}

  writeValue(obj: string[]): void {
    if (obj != null) {
      this.options.forEach(group => {
        group.permissions.forEach(opt => {
          opt.selected = obj.includes(opt.val);
        });
      });
    }
  }

  valueChanged(item, selected) {
    this.options.forEach(group => {
      group.permissions.forEach(opt => {
        if (opt.val === item) {
          opt.selected = selected;
        }
        if (opt.selected && !opt.canDisplay(this.flattenedPermissions)) {
          opt.selected = false;
        }
      });
    });
    this.onChange(
      this.options
        .flatMap(x => x.permissions)
        .filter(x => x.selected)
        .map(x => x.val)
    );
  }
}
export interface SelectablePermission {
  val: string;
  selected: boolean;
  display: string;
  canDisplay: (opts: SelectablePermission[]) => Observable<boolean>;
}
export interface SelectablePermissionGroup {
  title: string;
  permissions: SelectablePermission[];
  canDisplay: (opts: SelectablePermission[]) => boolean;
}

export class PermissionGroup {
  constructor(
    title: string,
    permissions: PermissionOption[],
    canDisplay?: (opts: SelectablePermission[]) => boolean
  ) {
    this.title = title;
    this.permissions = permissions;
    if (canDisplay != null) {
      this.canDisplay = canDisplay;
    } else {
      this.canDisplay = (opts: SelectablePermission[]) => true;
    }
  }
  title: string;
  permissions: PermissionOption[];
  canDisplay: (opts: SelectablePermission[]) => boolean;
}

export class PermissionOption {
  constructor(
    val: string,
    display: string,
    canDisplay?: (opts: SelectablePermission[]) => Observable<boolean>
  ) {
    this.val = val;
    this.display = display;
    if (canDisplay != null) {
      this.canDisplay = canDisplay;
    } else {
      this.canDisplay = (opts: SelectablePermission[]) => of(true);
    }
  }

  val: string;
  display: string;
  canDisplay: (opts: SelectablePermission[]) => Observable<boolean>;
}
